export default {
  gift_card_removed: 'Cadeaubon verwijderd',
  invalid_gift_card: 'Cadeaubon is ongeldig',
  gift_card_applied: 'Cadeaubon toegepast',
};
